import * as React from "react";

type Props = React.VideoHTMLAttributes<HTMLVideoElement>;

const Video: React.FC<Props> = ({ autoPlay, playsInline, ...props }) => {
  return (
    <video
      autoPlay={autoPlay}
      playsInline={playsInline || autoPlay}
      {...props}
    />
  );
};

export { Video };

export default Video;
